<template>
<div class="chapter">
<div class="inner_page">
<p class="C154"><em><a href="#/html/06_Contents#id_1003" id="page_xiii">Abbreviations</a></em></p>
<div class="table">
<table>
<tbody><tr class="Row_Style2"><td class="Col_Style2">AD</td>
<td class="Col_Style1">African Descent</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">AMA</td>
<td class="Col_Style1">American Missionary Association</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">Co.</td>
<td class="Col_Style1">Company</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">Col.</td>
<td class="Col_Style1">Colonel</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">CRA</td>
<td class="Col_Style1">Contraband Relief Association</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">LSASTC</td>
<td class="Col_Style1">Ladies’ Sanitary Association of St. Thomas’s African Episcopal Church</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">LUA</td>
<td class="Col_Style1">Ladies’ Union Association</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">PAS</td>
<td class="Col_Style1">Pennsylvania Abolition Society</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">POW</td>
<td class="Col_Style1">Prisoner of War</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">Regt.</td>
<td class="Col_Style1">Regiment</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">RG</td>
<td class="Col_Style1">Record Group</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">Sgt.</td>
<td class="Col_Style1">Sergeant</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">USCC</td>
<td class="Col_Style1">United States Christian Commission</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">USCHA</td>
<td class="Col_Style1">United States Colored Heavy Artillery</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">USCI</td>
<td class="Col_Style1">United States Colored Infantry</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">USCLA</td>
<td class="Col_Style1">United States Colored Light Artillery</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">USCT</td>
<td class="Col_Style1">United States Colored Troops</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">USSC</td>
<td class="Col_Style1">United States Sanitary Commission</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style2">WAA</td>
<td class="Col_Style1"><em>Weekly Anglo-African</em></td>
</tr>
<tr class="Row_Style1"><td class="Col_Style2">WCRA</td>
<td class="Col_Style1">Women’s Central Relief Association</td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_List_of_Abbreviations.vue?1172e865